import {useEffect, useRef, useState} from "react";
import Axios from "axios";


function useCancelableAxiosGet() {
  const cancelerRef = useRef();

  const [response, setResponse] = useState();
  const [url, setUrl] = useState();
  const [config, setConfig] = useState({});
  const [isEnable, setIsEnable] = useState(true);

  useEffect(
    () => {
      if ( !url || !isEnable ) {
        return;
      }

      if ( cancelerRef.current ) {
        const cancel = cancelerRef.current;
        cancel("Operation canceled by the user.");
      }

      Axios.get(url, {
        ...config,
        cancelToken: new Axios.CancelToken(function executor(canceler) {
          cancelerRef.current = canceler;
        }),
      })
        .then(data => {
          setResponse(data);
        })
        .catch(thrown => {
          if ( Axios.isCancel(thrown) ) {
            console.log("Request canceled", thrown.message);
          }
        })
        .finally(() => {
          cancelerRef.current = null;
        });
    },
    [isEnable, url, config],
  );

  return { setIsEnable, setUrl, setConfig, response };
}


export default useCancelableAxiosGet;
